// A component to override some global styles set in _reset.scss, Main.scss

import { styled } from 'src/components/mui';

export const ResetContainer = styled('div')(() => ({
  'h1, h2, h3, h4, h5, h6': {
    fontWeight: 'bold',
    fontStyle: 'inherit',
  },
  em: {
    fontStyle: 'italic',
  },
}));
